export const bugsnagClientNotify = (text = '', metaData = {}) => {
  const { bugsnagClient } = window;
  
  if(!bugsnagClient) return null;

  bugsnagClient.notify(new Error(text, { metaData }));
}